import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api';

const KEYS = {
  all: ['dashboard'] as const,
  stats: (month?: string, status?: string, userId?: string) => [...KEYS.all, 'stats', month, status, userId] as const,
  earningsHistory: (months?: number, status?: string, userId?: string) => [...KEYS.all, 'earnings-history', months, status, userId] as const,
  treatmentBreakdown: (month?: string, status?: string, userId?: string) => [...KEYS.all, 'treatment-breakdown', month, status, userId] as const,
  weeklyActivity: (month?: string, status?: string, userId?: string) => [...KEYS.all, 'weekly-activity', month, status, userId] as const,
  monthlySummary: (month?: string, status?: string, userId?: string) => [...KEYS.all, 'monthly-summary', month, status, userId] as const,
  recentReports: (limit?: number, userId?: string) => [...KEYS.all, 'recent-reports', limit, userId] as const,
};

export function useDashboardStats(month?: string, status?: string, userId?: string) {
  return useQuery({
    queryKey: KEYS.stats(month, status, userId),
    queryFn: async () => {
      const { data } = await dashboardApi.getStats(month, status, userId);
      return data.stats;
    },
  });
}

export function useEarningsHistory(months?: number, status?: string, userId?: string) {
  return useQuery({
    queryKey: KEYS.earningsHistory(months, status, userId),
    queryFn: async () => {
      const { data } = await dashboardApi.getEarningsHistory(months, status, userId);
      return { history: data.history, reportTypes: data.reportTypes };
    },
  });
}

export function useTreatmentBreakdown(month?: string, status?: string, userId?: string) {
  return useQuery({
    queryKey: KEYS.treatmentBreakdown(month, status, userId),
    queryFn: async () => {
      const { data } = await dashboardApi.getTreatmentBreakdown(month, status, userId);
      return data.breakdown;
    },
  });
}

export function useWeeklyActivity(month?: string, status?: string, userId?: string) {
  return useQuery({
    queryKey: KEYS.weeklyActivity(month, status, userId),
    queryFn: async () => {
      const { data } = await dashboardApi.getWeeklyActivity(month, status, userId);
      return { activity: data.activity, reportTypes: data.reportTypes };
    },
  });
}

export function useMonthlySummary(month?: string, status?: string, userId?: string) {
  return useQuery({
    queryKey: KEYS.monthlySummary(month, status, userId),
    queryFn: async () => {
      const { data } = await dashboardApi.getMonthlySummary(month, status, userId);
      return data.summary;
    },
  });
}

export function useRecentReports(limit?: number, userId?: string) {
  return useQuery({
    queryKey: KEYS.recentReports(limit, userId),
    queryFn: async () => {
      const { data } = await dashboardApi.getRecentReports(limit, userId);
      return data.reports;
    },
  });
}
